import { render, staticRenderFns } from "./DefaultIframe.vue?vue&type=template&id=d5fa5b3c&scoped=true"
import script from "./DefaultIframe.vue?vue&type=script&lang=js"
export * from "./DefaultIframe.vue?vue&type=script&lang=js"
import style0 from "./DefaultIframe.vue?vue&type=style&index=0&id=d5fa5b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fa5b3c",
  null
  
)

export default component.exports